/**
 * Web twin of audioSessionCoordinator: there is no shared OS audio session to
 * coordinate in the browser (getUserMedia streams and media elements coexist
 * natively, and expo-audio's setAudioModeAsync is a no-op there), and
 * importing @livekit/react-native here would pull native-only modules into the
 * web bundle.
 */

export const prepareRecordingSession = async (): Promise<void> => {}

export const reassertLiveSession = async (): Promise<void> => {}

export const releaseRecordingSession = async (): Promise<void> => {}
